import React from "react";
import { Link } from "react-router-dom";
import { formatPhoneNumber, formatDoctorName } from "../../../helpers/formatting";
import { getDirectionsUrl } from "../../../helpers/location";
import * as types from "../../../constants/actionTypes";
import { connect } from "react-redux";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import * as d from "../../../reducers/domainReducer";
import VideoVisitTips from "../appointment/VideoVisitTips";
import VideoVisitLaunch from "../appointment/VideoVisitLaunch";
import ECheckInCTA from "../appointment/ECheckInCTA";
import AppointmentInPersonTile from "../appointment/appointmentInPersonTile";
import AppointmentVideoVisitTile from "../appointment/appointmentVideoVisitTile";
import { AddressLink, PhoneLink } from "../../ecosystem/mybswh";
import Video from 'twilio-video';
import { Typography, Icon, Divider } from "../../ecosystem/"
import { DashboardTile } from "../DashboardTile";

const TIME_FORMAT = "LT";

/**
 * Container component for the AppointmentDetail page.
 * 
 */
export class AppointmentDetail extends React.Component {

    constructor(props, params) {
        super(props, params);
        this.seeAllAppointments = this.seeAllAppointments.bind(this);
        var bClientSide = (typeof window !== "undefined");
        if (bClientSide) {
            this.state = {
                viewAppointmentsLink: `${window.serverData.data.ssoBaseURL}MyChart/Open?myChartModule=mc-Appointments`,
                showVideoVisitTipsModal: false,
                apptTypeHidden: '',
                enableLaunchButton: this.canEnableVideoVisit,
                roomOpensTime: "",
                roomClosingTime: "",
                roomTimePassed: false
            };
        }
        const me = this;
        this.isSDCVisit = false;
        this.isRequireEcheckin = false;

        this.updateLaunchButtonStatus = this.updateLaunchButtonStatus.bind(this);
        this.handleVideoVisitLaunch = this.handleVideoVisitLaunch.bind(this);

        // set a timer to enable the launch button when it's time for the visit to start, and disable it when the visit has expired.
        this.timer = setInterval(() => {
            // only update state when a change occurs...
            me.updateLaunchButtonStatus();
        }, 5000);
    }

    /*componentWillMount() {

    }*/

    componentDidMount() {
        logUI("MBHWeb.UI.AppointmentDetail.ComponentDidMount", new Date(), Tools.getURLPath());
        this.updateLaunchButtonStatus();
    }

    componentDidUpdate(prevProps) {
        const currentPatientName = this.props.appointmentDetails && this.props.appointmentDetails.patientName ? this.props.appointmentDetails.patientName : "";
        const prevPatientName = prevProps.appointmentDetails && prevProps.appointmentDetails.patientName ? prevProps.appointmentDetails.patientName : "";
        if (currentPatientName !== prevPatientName) {
            this.updateLaunchButtonStatus();
        }
    }

    seeAllAppointments() {
        history.push("/appointments");
        //window.location.href = this.state.viewAppointmentsLink;
    }

    getTileMessage = () => {
        const { appointmentDetails, visitTypeForSDC, videoVisitTypesForECheckIn } = this.props;
        let showDoctorMessage = false;
        let showVideoVisitLaunchButton = false;
        const videoVisitTypesForDoctorMessage = window && window.serverData && window.serverData.data && window.serverData.data.videoVisitTypesForDoctorMessage ? window.serverData.data.videoVisitTypesForDoctorMessage : null;
        const videoVisitTypesForLaunchButton = window && window.serverData && window.serverData.data && window.serverData.data.videoVisitTypesForLaunchButton ? window.serverData.data.videoVisitTypesForLaunchButton : null;
        const visitTypeIds = appointmentDetails && appointmentDetails.visitTypeIDs;
        const currentVisitTypeId = Tools.findInternalId(visitTypeIds);
        showDoctorMessage = isVisitTypeIDExist(currentVisitTypeId, videoVisitTypesForDoctorMessage);
        showVideoVisitLaunchButton = isVisitTypeIDExist(currentVisitTypeId, videoVisitTypesForLaunchButton);
        this.isSDCVisit = currentVisitTypeId && currentVisitTypeId === visitTypeForSDC ? true : false;
        this.isRequireEcheckin = isVisitTypeIDExist(currentVisitTypeId, videoVisitTypesForECheckIn);
        return { showDoctorMessage, showVideoVisitLaunchButton };
    }

    handleVideoVisitLaunch() {
        logUI("MBHWeb.Dashboard.AppointmentTile.LaunchVideoVisit.Click", new Date(), Tools.getURLPath());
        this.props.videoVisitLink ? this.props.history.push({ pathname: this.props.videoVisitLink }) : this.props.history.push({ pathname: "/videovisit/" + this.props.appointmentDetails.csnIdOfAppointment });
    }

    updateLaunchButtonStatus() {
        this.canEnableVideoVisit = this.isTimeToStartVideoVisit();
        const { enableLaunchButton } = this.state;
        const { isRequireEcheckin, eCheckinCompleted } = this.props;
        if (enableLaunchButton !== this.canEnableVideoVisit) {
            this.setState({ enableLaunchButton: this.canEnableVideoVisit });
            const isButtonEnabled = this.canEnableVideoVisit ? isRequireEcheckin ? eCheckinCompleted : true : false;
            const currentTimeInCST = Tools.getCentralDateWithFormat(new Date(), "MM-DD-YYYY HH:mm:ss");
            logUI(`MBHWeb.UI.VideoVisit.LaunchButton.${isButtonEnabled ? "Enabled" : "Disabled"}`, new Date(), Tools.getURLPath(),
                {
                    "isTimeToStartVisit": this.canEnableVideoVisit,
                    "isRequireEcheckin": isRequireEcheckin,
                    "isECheckinCompleted": eCheckinCompleted,
                    "currentTimeInCST": currentTimeInCST
                });
        }
    }

    isVideoVisitToday() {
        const appointmentDetails = this.props.appointmentDetails;
        let isVisitToday = false;
        if (appointmentDetails && appointmentDetails.appointmentDateTime) {
            isVisitToday = Tools.isVisitToday(appointmentDetails.appointmentDateTime);
        }
        return isVisitToday;
    }

    isTimeToStartVideoVisit() {
        const videoVisit = this.props.appointmentDetails;
        const visitsEnabled = window.serverData.data.ambulatoryVideoVisitEnabled;
        var ret = false;

        if (visitsEnabled && videoVisit && videoVisit.appointmentDateTime) {
            // const minutesBefore = window.serverData.data.videoVisitEnabledMinutesBeforeStart;
            //const minutesAfter = window.serverData.data.videoVisitEnabledMinutesAfterStart;
            const { videoVisitEnabledMinutesBeforeStart, videoVisitEnabledMinutesAfterStart,
                SDCVisitEnabledMinutesBeforeStart, SDCVisitEnabledMinutesAfterStart } = this.props;
            const minutesBefore = this.props.isSDCVisit ? SDCVisitEnabledMinutesBeforeStart : videoVisitEnabledMinutesBeforeStart;
            const minutesAfter = this.props.isSDCVisit ? SDCVisitEnabledMinutesAfterStart : videoVisitEnabledMinutesAfterStart;

            const visitDateTimeBefore = Tools.subtractMinutesFromDate(videoVisit.appointmentDateTime, minutesBefore);//apptDateTime.clone().subtract(minutesBefore,"minutes");
            const visitDateTimeAfter = Tools.addMinutesToDate(videoVisit.appointmentDateTime, minutesAfter);//apptDateTime.clone().add(minutesAfter, "minutes");

            // get room open time            
            this.setState({ roomOpensTime: Tools.formatCentralDate(visitDateTimeBefore, TIME_FORMAT), roomClosingTime: Tools.formatCentralDate(visitDateTimeAfter, TIME_FORMAT) });

            // check the date
            if (this.isVideoVisitToday()) {
                if (Tools.isBetween(visitDateTimeBefore, visitDateTimeAfter)) {
                    ret = true;
                    this.setState({ roomTimePassed: false });
                }
                else if (Tools.isAfter(visitDateTimeAfter)) {
                    this.setState({ roomOpensTime: "", roomClosingTime: "", roomTimePassed: true });
                } else {
                    this.setState({ roomTimePassed: false });
                }
            }
        }

        return ret;
    }

    getAddressMarkup = (disabled) => {
        const { appointmentDetails } = this.props;
        return appointmentDetails && appointmentDetails?.address
            ? <AddressLink
                address={appointmentDetails}
                street1Key="address"
                onClick={() => logUI("MBHWeb.UI.Dashboard.AppointmentTile.Address.Click", new Date(), Tools.getURLPath())}
                disabled={disabled}
            />
            : ''
    }

    getPhoneNumberMarkup = (disabled) => {
        const { appointmentDetails } = this.props;
        const phoneNumber = (appointmentDetails && appointmentDetails?.phone) ? appointmentDetails?.phone : "";
        return phoneNumber
            ? <PhoneLink
                phone={phoneNumber}
                onClick={() => logUI("MBHWeb.UI.Dashboard.AppointmentTile.PhoneNumber.Click", new Date(), Tools.getURLPath())}
                disabled={disabled}
            />
            : ''
    }

    render() {
        const { appointmentDetails, isMobile, index, disabled, visit, pricing } = this.props;
 
        const { showVideoVisitLaunchButton } = this.getTileMessage();

        return (
            <>
                {showVideoVisitLaunchButton
                    ? <AppointmentVideoVisitTile
                        appointmentDetails={appointmentDetails}
                        visit={visit}
                        isMobile={isMobile}
                        isRequireEcheckin={this.isRequireEcheckin}
                        isSDCVisit={this.isSDCVisit}
                        getPhoneNumberMarkup={this.getPhoneNumberMarkup}
                    />
                    : <AppointmentInPersonTile
                        appointmentDetails={appointmentDetails}
                        visit={visit}
                        isMobile={isMobile}
                        isRequireEcheckin={this.isRequireEcheckin}
                        getAddressMarkup={this.getAddressMarkup}
                        getPhoneNumberMarkup={this.getPhoneNumberMarkup}
                      />
                }                  
            </>
        );
    }
}

const isVisitTypeIDExist = (source, visitType) => {
    const visitTypes = visitType ? visitType.split(',') : null;
    if (!visitTypes || !source) return false;
    let isVisitTypeExist = false;
    for (let i = 0; i < visitTypes.length; i++) {
        if (visitTypes[i] === source) {
            isVisitTypeExist = true;
            break;
        }
    }
    return isVisitTypeExist;
};

const mapStateToProps = (state, ownProps) => {
    return {
        isLoggedIn: state.domain.li,
        hasMyChart: state.domain.hm,
        dashboardData: state.dashboard.dashBoardDetails,
        dashboardBFF: state.dashboard.bffDashboardData,
        visit: state.dashboard.bffDashboardData.data.visits.find(el => { if (state.dashboard.dashBoardDetails && state.dashboard.dashBoardDetails.Appointments) return el.csnIdOfAppointment === state.dashboard.dashBoardDetails.Appointments.CsnIdOfAppointment }),
        dashboardServiceError: state.dashboard.error,
        history: state.session.history,
        serverData: state.session.serverData,
        locations: state.locations,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        visitTypeForSDC: state.session.serverData && state.session.serverData.visitTypeForSDC ? state.session.serverData.visitTypeForSDC : "60148",
        ssoBaseUrl: state.session.serverData ? state.session.serverData.ssoBaseURL : "",
        videoVisitTypesForECheckIn: state.session.serverData && state.session.serverData.videoVisitTypesForECheckIn ? state.session.serverData.videoVisitTypesForECheckIn : "",
        pricing: state.pricing
    };
};


export default connect(mapStateToProps, "")(AppointmentDetail);

